/* eslint-disable */

import Controller from 'ui/toggle/Controller';
import Observer from 'utils/Observer';

/**
 * Default values for attribute and states.
 * @constant
 */
const ATTRIBUTE = 'data-toggle-active';
const ACTIVE_STATE = 'true';
const INACTIVE_STATE = 'false';
const ACTIVE_EVENT = 'active';
const INACTIVE_EVENT = 'inactive';
const FLAG = '';

/**
 * Class Toggle.
 * @class
 */
class Toggle {

    /**
     * Make a new Toggle.
     * @constructs
     * @param {HTMLElement} element
     * @param {{}} options
     */
    constructor(element, options) {
        this._element = element

        if (!element) return;
        this._options = options || {};
        this._options.attribute = this._options.attribute || ATTRIBUTE;
        this._options.flag = this._options.flag || FLAG;
        this._options.activeState = this._options.activeState || ACTIVE_STATE;
        this._options.inActiveState = this._options.inActiveState || INACTIVE_STATE;
        this._id = this._element && this._element.getAttribute('id');
        this._parent = this._options.switchParent && this._element.closest(this._options.switchParent)
        this._switchPanels = this._parent && [...this._parent.querySelectorAll(`[data-switch-${this._options.flag}]`)];
        this.active = false;
        this.body = document.body;
        this._initialize();

    }

    /**
     * Initialize
     * @private
     */
    _initialize() {

        let attr = this._element.getAttribute(this._options.attribute);
        if (!attr) {
            this.attribute = this._options.inActiveState;
            this._options.flag.length > 0 && this.body.setAttribute(`data-${this._options.flag}`, this._options.inActiveState)
        }
        else if (attr === this._options.activeState) {
            this.active = true;
            this._options.flag.length > 0 && this.body.setAttribute(`data-${this._options.flag}`, this._options.activeState)
        }

        Controller.register(this);

    }

    switch() {
        !this.active ? this.activate() : this.deactivate();
    }

    /**
     * Activating the toggle by changing the attribute active value.
     * @public
     */
    activate() {
        this.attribute = this._options.activeState;
        this.active = true;
        this._options.flag.length > 0 && this.body.setAttribute(`data-${this._options.flag}`, ACTIVE_STATE);
        this._element.setAttribute(`${this._options.attribute}`, ACTIVE_STATE);
        this._switchPanels && this.handlePanelsVisibility()
        Observer.publish(this, ACTIVE_EVENT, this);
    }

    /**
     * Deactivating the toggle by changing the attribute inactive value.
     * @public
     */
    deactivate() {
        this.attribute = this._options.inActiveState;
        this.active = false;
        this._options.flag.length > 0 && this.body.setAttribute(`data-${this._options.flag}`, INACTIVE_STATE);
        this._element.setAttribute(`${this._options.attribute}`, INACTIVE_STATE);
        this._switchPanels && this.handlePanelsVisibility()
        Observer.publish(this, INACTIVE_EVENT, this);
    }

    /**
     * Switch panels visibility
     * @public
     */
    handlePanelsVisibility() {
        this._switchPanels.forEach(panel => {
            const isHidden = panel.getAttribute('aria-hidden') === 'true';
            panel.setAttribute('aria-hidden', !isHidden);
        })
    }

    /**
     * Set te active attribute on the DOM element.
     * @public
     * @param {String} name
     */
    set attribute(name) {
        this._element.setAttribute(this._options.attribute, name);
    }

    /**
     * Expose the id.
     * @public
     */
    get id() {
        return this._id;
    }

    /**
     * Expose the group name.
     * @public
     */
    get group() {
        return this._options.group;
    }

    /**
     * Expose the toggle active event.
     * @public
     */
    get activeEvent() {
        return ACTIVE_EVENT;
    }

    /**
     * Expose the toggle inactive event.
     * @public
     */
    get inActiveEvent() {
        return INACTIVE_EVENT;
    }

    /**
     * Unload and reset everything if conditions no longer apply.
     * @method unload
     * @public
     */
    unload() {

        Controller.unregister(this);
        this._element.removeAttribute(this._options.attribute);

    }

}

export default Toggle;
